import { render } from "./viewport-guide-mode.svg?vue&type=template&id=9366c4c0"
const script = {}

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__